import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=954e1afc"
import script from "./Dummy.vue?vue&type=script&lang=ts"
export * from "./Dummy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports